import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

import { KYMW5002ImageInfoDetailBoxComponent } from './kymw5002-image-info-detail-box.component';

/**
 * EC使用画像指示画面 モジュール設定クラス
 *
 * @export KYMW5002ImageInfoDetailBoxModule
 * @class KYMW5002ImageInfoDetailBoxModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjInputModule,
    WjGridModule
  ],
  declarations: [
    KYMW5002ImageInfoDetailBoxComponent,
  ],
  providers: [
  ],
  exports: [
    KYMW5002ImageInfoDetailBoxComponent,
  ]
})
export class KYMW5002ImageInfoDetailBoxModule {

}
